const rootRelativePrefixes = ['image-cache/', 'image/cache/'];

export function toRootRelativeImagePath(path?: string) {
    if (!path) {
        return path;
    }

    if (!rootRelativePrefixes.some(prefix => path.startsWith(prefix))) {
        return path;
    }

    return `/${path}`;
}
